import React, { useContext } from 'react';
import { ListContext } from '@contexts/ListContext';
import styled from 'styled-components';


const TransactionTitleContainer = styled.div`
    display: ${props => props.$inline ? 'flex' : 'block'};
    ${props => props.$inline && 'align-items: center;'}

    .transaction-title {
        font-size: ${props => props.theme.FontSizeSm};
        font-weight: 600;
        text-transform: uppercase;
    }

    small {
        font-weight: 300;
        font-size: ${props => props.theme.FontSizeSm};
        text-transform: uppercase;
        line-height:1em;
        display: block;
        padding-right: ${props => props.$inline ? '.25rem' : '0'};

        &:after {
            content: ${props => props.$inline ? '" - "': '""'};
        }
    }
`;


const TransactionTitleLine = ({ transaction, inline }) => {
    const { GetTransactionLabelName, GetFamilyName } = useContext(ListContext);


    const title = transaction.Title
    let transactionFamily = GetFamilyName(transaction.Family)
    let transactionTitle = ''

    if (transaction.TransactionLabelID) {
        const labelname = GetTransactionLabelName(transaction.Family, transaction.TransactionLabelID)
        if (title === "") {
            transactionTitle = labelname
        } else {
            if (title.toLocaleLowerCase() !== labelname.toLocaleLowerCase()) {
                transactionFamily += ` / ${labelname}`
            }
            transactionTitle = title
        }
    } else {
        transactionTitle = title
    }

    return (
        <TransactionTitleContainer $inline={inline}>
            {(transactionFamily !== transactionTitle) && <small>{transactionFamily}</small>}
            <div className='transaction-title'>{transactionTitle}</div>
        </TransactionTitleContainer>
    )
}

export default TransactionTitleLine
